interface LogoWithNameProps {
  scale?: number
}

export function LogoWithName ({ scale = 1 }: LogoWithNameProps) {
  return (
    <svg
      width={102 * scale}
      height={24 * scale}
      viewBox='0 0 166 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={{ transform: `scale(${scale})` }}
    >
      <mask
        id='mask0_4_1219'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='33'
        height='40'
      >
        <path d='M13.0232 11.145H11.1847V40H13.0232V11.145Z' fill='#C4C4C4' />
        <path d='M21.45 11.145H19.6115V39.3893H21.45V11.145Z' fill='#C4C4C4' />
        <path d='M13.0232 11.145H0V12.9771H13.0232V11.145Z' fill='#C4C4C4' />
        <path
          d='M32.6347 11.145H19.6115V12.9771H32.6347V11.145Z'
          fill='#C4C4C4'
        />
        <path
          d='M20.5307 1.52672H0.459641V3.35878H20.5307V1.52672Z'
          fill='#C4C4C4'
        />
        <path d='M1.83857 1.52672H0V12.9771H1.83857V1.52672Z' fill='#C4C4C4' />
        <path
          d='M32.6347 2.44275H30.7961V12.9771H32.6347V2.44275Z'
          fill='#C4C4C4'
        />
        <path
          d='M19.6115 4.8855C20.9654 4.8855 22.0629 3.79184 22.0629 2.44275C22.0629 1.09366 20.9654 0 19.6115 0C18.2576 0 17.16 1.09366 17.16 2.44275C17.16 3.79184 18.2576 4.8855 19.6115 4.8855Z'
          fill='#C4C4C4'
        />
        <path
          d='M20.5307 40C21.8846 40 22.9822 38.9064 22.9822 37.5573C22.9822 36.2082 21.8846 35.1145 20.5307 35.1145C19.1769 35.1145 18.0793 36.2082 18.0793 37.5573C18.0793 38.9064 19.1769 40 20.5307 40Z'
          fill='#C4C4C4'
        />
      </mask>
      <g mask='url(#mask0_4_1219)'>
        <path
          d='M45.5047 -0.610687H-13.0232V42.2901H45.5047V-0.610687Z'
          fill='url(#paint0_linear_4_1219)'
        />
      </g>
      <path
        d='M49.8931 26.7296V13.1408H45V11.2704H56.8058V13.1408H51.8711V26.7296H49.8931Z'
        fill='#303030'
      />
      <path
        d='M65.2686 26.7296V11.2704H67.2467V17.8958H75.0131V11.2704H77.012V26.7296H75.0131V19.7662H67.2467V26.7296H65.2686Z'
        fill='#303030'
      />
      <path
        d='M85.2017 26.7296L90.8443 11.2704H93.447L99.1104 26.7296H96.9658L95.5708 22.8986H88.6164L87.2422 26.7296H85.2017ZM89.2619 21.0732H94.9045L93.1763 16.2282C93.1347 16.093 93.0722 15.9052 92.9889 15.6648C92.9056 15.4244 92.8154 15.1615 92.7182 14.8761C92.6211 14.5756 92.5239 14.2751 92.4267 13.9746C92.3296 13.6592 92.2393 13.3737 92.1561 13.1183H92.0311C91.934 13.4188 91.8229 13.7643 91.698 14.1549C91.573 14.5455 91.4481 14.9286 91.3232 15.3042C91.1983 15.6648 91.0942 15.9728 91.0109 16.2282L89.2619 21.0732Z'
        fill='#303030'
      />
      <path
        d='M108.974 26.7296V13.1408H104.081V11.2704H115.887V13.1408H110.952V26.7296H108.974Z'
        fill='#303030'
      />
      <path
        d='M129.962 26.7296C128.505 26.7296 127.27 26.4441 126.256 25.8732C125.243 25.2873 124.466 24.4085 123.924 23.2366C123.397 22.0498 123.133 20.8178 123.133 19C123.133 16.3108 123.737 14.5756 124.944 13.2535C126.152 11.9315 127.832 11.2704 129.983 11.2704C131.205 11.2704 132.287 11.4883 133.231 11.9239C134.175 12.3446 134.911 12.9906 135.438 13.862C135.98 14.7183 136.251 15.8 136.251 17.107H134.252C134.252 16.2056 134.071 15.462 133.71 14.8761C133.363 14.2901 132.87 13.8545 132.232 13.569C131.593 13.2685 130.844 13.1183 129.983 13.1183C128.984 13.1183 128.123 13.3286 127.401 13.7493C126.68 14.17 126.131 14.8235 125.756 15.7099C125.382 16.5812 125.194 17.4376 125.194 18.8197V19.293C125.194 20.6601 125.382 21.5089 125.756 22.3803C126.131 23.2366 126.673 23.8676 127.381 24.2732C128.102 24.6789 128.97 24.8817 129.983 24.8817C130.872 24.8817 131.635 24.739 132.274 24.4535C132.926 24.1681 133.426 23.7324 133.773 23.1465C134.134 22.5455 134.314 22.0648 134.314 21.1634H136.251C136.251 22.5005 135.973 23.3268 135.418 24.1831C134.876 25.0394 134.134 25.6779 133.19 26.0986C132.246 26.5193 131.17 26.7296 129.962 26.7296Z'
        fill='#303030'
      />
      <path
        d='M145.257 26.7296V11.2704H147.235V17.8958H155.001V11.2704H157V26.7296H155.001V19.7662H147.235V26.7296H145.257Z'
        fill='#303030'
      />
      <defs>
        <linearGradient
          id='paint0_linear_4_1219'
          x1='16.2407'
          y1='-0.610687'
          x2='16.2407'
          y2='42.2901'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#230DAC' />
          <stop offset='1' stopColor='#FB09C6' />
        </linearGradient>
      </defs>
    </svg>
  )
}
